import React, {useState} from "react";
import {Box, Chip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useTheme} from "@mui/material/styles";
import PropTypes from "prop-types";
import moment from "moment";
import EditButton from "./editButton";
import StyledTypography from "./StyledTypography";
import {setStateHistory} from "../store/stateHistorySlice";
import {GetLatestDate, GetMachineTypeIcon} from "../utils/systemInfo";
export default function StateHistoryComponent({row, triggerToggleDrawer, usersList, locationsList}) {
    const theme = useTheme();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const timezoneMins = useSelector(({timezone}) => timezone);
    const [imageError, setImageError] = useState(false);
    // const handleButton = (event, buttonType, row) => {
    const handleButton = () => {
        dispatch(setStateHistory(row));
        triggerToggleDrawer(true);
    };
    function getUserName(id) {
        const objectuser = usersList.find((x) => x.profile_uid.toString() === id);
        return objectuser ? `${objectuser?.firstname} ${objectuser?.lastname}` : "";
    }

    return (
        <Box sx={{display: "flex", flexFlow: "column", mr: "10px"}}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: {xs: "block", sm: "center"},
                    mb: "10px"
                }}>
                <Box display="flex" alignItems="center">
                    <StyledTypography sx={{ml: "10px"}} variant={"h6"}>
                        {t(row.state_type)}
                    </StyledTypography>
                    {row.device_state_history_tags &&
                        row.device_state_history_tags.map((tag, index) => (
                            <Chip
                                key={index}
                                label={tag.tag_name}
                                sx={{
                                    ml: "4px",
                                    backgroundColor: tag.tag_color,
                                    color: "white"
                                }}
                                size="small"
                            />
                        ))}
                </Box>
                <EditButton key={"edit"} small onClick={handleButton} />
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center">
                    {row.device_profile?.vehicle_type && (
                        <StyledTypography variant="body2">
                            <div
                                style={{width: "40px", marginLeft: "10px"}}
                                dangerouslySetInnerHTML={{
                                    __html: GetMachineTypeIcon(row.device_profile.vehicle_type).replace("theme.palette.custom.text", theme.palette.custom.text)
                                }}
                            />
                        </StyledTypography>
                    )}
                    {row.device_profile?.name && (
                        <StyledTypography sx={{ml: "10px"}} variant="body2">
                            {row.device_profile.name}
                        </StyledTypography>
                    )}
                    {row.device_profile?.oem && (
                        <StyledTypography sx={{ml: "10px"}} variant="body2">
                            {!imageError ? <img width="40px" src={`${window.env.REACT_APP_PUBLIC_URL}/images/oem/${String(row.device_profile.oem).replaceAll(" ", "")}_${localStorage.getItem("color_theme") === "dark" ? "Dark" : "Light"}.png`} alt={row.device_profile.oem} onError={() => setImageError(true)} /> : <span>{row.device_profile.oem}</span>}
                        </StyledTypography>
                    )}
                </Box>
                <Box display="flex" alignItems="center">
                    {GetLatestDate([row.device_profile?.dst_last_opsum, row.device_profile?.latest_data_dst, row.device_profile?.dst_last_seen]) ? (
                        <StyledTypography sx={{ml: "10px"}} variant={"body2"}>
                            {`${t("Last Seen")}`}:{" "}
                            {moment
                                .utc(GetLatestDate([row.device_profile?.dst_last_opsum, row.device_profile?.latest_data_dst, row.device_profile?.dst_last_seen]))
                                .add(timezoneMins, "minutes")
                                .format("YYYY-MM-DD HH:mm")}
                        </StyledTypography>
                    ) : null}
                </Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center">
                    <StyledTypography sx={{ml: "10px"}} variant="body2">
                        {`${t("Start Time")}`}: {moment.utc(row.state_start).add(timezoneMins, "minutes").format("YYYY-MM-DD HH:mm")}
                    </StyledTypography>

                    {row.state_end && row.state_end > row.state_start && (
                        <StyledTypography sx={{ml: "10px"}} variant="body2">
                            {`${t("Duration")}`}: {`${Math.floor(moment(row.state_end).diff(moment(row.state_start), "minutes") / 60)}:${moment(row.state_end).diff(moment(row.state_start), "minutes") % 60} ${t("Hours")}`}
                        </StyledTypography>
                    )}
                </Box>
                <Box display="flex" alignItems="center">
                    {row.assigned_to_person_id && getUserName(row.assigned_to_person_id) && (
                        <StyledTypography sx={{ml: "10px"}} variant="body2">
                            {`${t("Assigned To")}`}: {getUserName(row.assigned_to_person_id)}
                        </StyledTypography>
                    )}

                    {(() => {
                        const location = locationsList.find((x) => x.operation_location_named_lookup_id === row.state_location_id);
                        const locationName = location?.name;

                        return locationName ? (
                            <StyledTypography sx={{ml: "10px"}} variant="body2">
                                {`${t("Location")}`}: {locationName}
                            </StyledTypography>
                        ) : null;
                    })()}
                </Box>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" sx={{mb: "10px"}}>
                <Box display="flex" alignItems="center">
                    {row.state_description && (
                        <Box display="flex" alignItems="center">
                            <StyledTypography sx={{ml: "10px"}} variant="body2">
                                {`${t("Description")}`}: {row.state_description}
                            </StyledTypography>
                        </Box>
                    )}
                </Box>
                <Box display="flex" alignItems="center">
                    {row.state_result && (
                        <Box display="flex" alignItems="center">
                            <StyledTypography sx={{ml: "10px"}} variant="body2">
                                {`${t("Result")}`}: {row.state_result}
                            </StyledTypography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
    //   return (
    //     <Box sx={{display: "flex", flexFlow: "column"}}>
    //         <Box
    //             sx={{
    //                 display: "flex",
    //                 justifyContent: "space-between",
    //                 alignItems: {xs: "block", sm: "center"}
    //             }}>
    //             <Box display="flex" alignItems="center">
    //                 <StyledTypography variant={"body2"}>
    //                     {row.device_profile?.vehicle_type ? (
    //                         <div
    //                             style={{width: "40px", marginLeft: "10px"}}
    //                             dangerouslySetInnerHTML={{
    //                                 __html: GetMachineTypeIcon(row.device_profile?.vehicle_type ?? "Unknown").replace("theme.palette.custom.text", theme.palette.custom.text)
    //                             }}
    //                         />
    //                     ) : null}
    //                 </StyledTypography>
    //                 <StyledTypography sx={{ml: "10px"}} variant={"h6"}>
    //                 {row.device_profile?.name ? row.device_profile?.name : "Device: Unknown"}
    //                 </StyledTypography>
    //                 <StyledTypography sx={{ml: "10px"}} variant={"body2"}>
    //                     {row.device_profile?.oem ? (
    //                         <>{!imageError ? <img width="40px" src={`${window.env.REACT_APP_PUBLIC_URL}/images/oem/${String(row.device_profile?.oem ?? "nerospec").replaceAll(" ", "")}_${localStorage.getItem("color_theme") === "dark" ? "Dark" : "Light"}.png`} alt={row.device_profile?.oem} onError={() => setImageError(true)} /> : <span>{row.device_profile.oem}</span>}</>
    //                     ) : "OEM: Unknown"}
    //                 </StyledTypography>
    //                 <StyledTypography sx={{ml: "10px"}} variant={"body2"}>
    //                     {`${t("Last Seen")}`}:{" "}
    //                     {GetLatestDate([row.device_profile?.dst_last_opsum, row.device_profile?.latest_data_dst, row.device_profile?.dst_last_seen])
    //                         ? moment
    //                               .utc(GetLatestDate([row.device_profile?.dst_last_opsum, row.device_profile?.latest_data_dst, row.device_profile?.dst_last_seen]))
    //                               .add(timezoneMins, "minutes")
    //                               .format("YYYY-MM-DD HH:mm")
    //                         : "Unknown"}
    //                 </StyledTypography>
    //             </Box>
    //         </Box>
    //         <Box
    //             display="flex"
    //             alignItems="center"
    //             sx={{
    //                 display: "flex",
    //                 justifyContent: "space-between",
    //                 alignItems: {xs: "block", sm: "center"}
    //             }}>
    //             <Box>
    //                 <StyledTypography sx={{ml: "10px"}} variant={"body2"}>
    //                     {t(row.state_type)}{" "}
    //                     {row.device_state_history_tags &&
    //                         row.device_state_history_tags.map((tag, index) => (
    //                             <Chip
    //                                 key={index}
    //                                 label={tag.tag_name}
    //                                 sx={{
    //                                     ml: "4px",
    //                                     backgroundColor: tag.tag_color,
    //                                     color: "white"
    //                                 }}
    //                                 size="small"
    //                             />
    //                         ))}
    //                 </StyledTypography>{" "}
    //             </Box>
    //             <EditButton key={"edit"} small onClick={handleButton} />
    //         </Box>
    //         <Box display="flex" alignItems="center">
    //             <StyledTypography sx={{ml: "10px"}} variant={"body2"}>
    //                 {row.state_end && row.state_end > row.state_start ? `${t("Duration")}:  ${Math.floor(moment(row.state_end).diff(moment(row.state_start), "minutes") / 60)}:${moment(row.state_end).diff(moment(row.state_start), "minutes") % 60} ${t("Hours")}` : `${t("Start Time")}: ${moment.utc(row.state_start).add(timezoneMins, "minutes").format("YYYY-MM-DD HH:mm")}`}
    //             </StyledTypography>
    //             <StyledTypography sx={{ml: "10px"}} variant={"body2"}>
    //                 {`${t("Assigned To")}`}: {row.assigned_to_person_id ? getUserName(row.assigned_to_person_id) : "Unknown"}
    //             </StyledTypography>
    //             <StyledTypography sx={{ml: "10px"}} variant={"body2"}>
    //                 {`${t("Location")}`}: {row.state_location_id ? (locationsList.find((x) => x.operation_location_named_lookup_id === row.state_location_id)?.name ? locationsList.find((x) => x.operation_location_named_lookup_id === row.state_location_id)?.name : "Unknown") : "Unknown"}
    //             </StyledTypography>
    //         </Box>
    //         <Box display="flex" alignItems="center">
    //             <StyledTypography sx={{ml: "10px"}} variant={"body2"}>
    //                 Result: {t(row.state_result ? row.state_result : "None")}
    //             </StyledTypography>
    //             <StyledTypography sx={{ml: "10px"}} variant={"body2"}>
    //                 Description: {t(row.state_description ? row.state_description : "None")}
    //             </StyledTypography>
    //         </Box>
    //     </Box>
    // );
}
StateHistoryComponent.propTypes = {
    row: PropTypes.object,
    triggerToggleDrawer: PropTypes.func,
    usersList: PropTypes.array,
    locationsList: PropTypes.array
};
